export default function (lnglat) {
  return `https://www.google.com/maps/search/?api=1&query=${lnglat[1]},${lnglat[0]}`;
}
